var transitionList = [...document.querySelectorAll('.colour__transition')];
var multi = document.querySelector('.multicolumn__transition');
var button = document.querySelector('.button__transition');
var tt = [...document.querySelectorAll('.text__transition')];
var og = [...document.querySelectorAll('.og__image')];
var alt = [...document.querySelectorAll('.alt__image')];
var previousBlock = document.querySelector('.previous__block');
var exit = document.querySelector('.exit__transition');

try {
  var transitionThreshold = transitionList[0].getAttribute('transition__threshold')
  } 
catch(err) {
  var transitionThreshold = 0
}

var t_options = {
  rootMargin: '30% 0% 0% 0%',
  threshold: transitionThreshold
}

let t_observer = new IntersectionObserver(change, t_options);

function change(backgrounds){
  backgrounds.forEach(background => {
    
    try {
      if (background.boundingClientRect.top < 0 ) {
        exit.classList.toggle("exit-color", !background.isIntersecting)
      } else {
        background.target.classList.toggle("transition-from", !background.isIntersecting)
      }
    }
    catch(err) {
      background.target.classList.toggle("transition-from", !background.isIntersecting)
    }
    
    try {
      multi.classList.toggle("transition-from", !background.isIntersecting)
      button.classList.toggle("button-transition", background.isIntersecting)

      for (let i = 0; i < tt.length; i++) {
        tt[i].classList.toggle("text-transition", background.isIntersecting);
      }

      for (let j = 0; j < og.length; j++) {
        og[j].classList.toggle("hide-img", background.isIntersecting);
      }

      for (let k = 0; k < alt.length; k++) {
        alt[k].classList.toggle("show-img", background.isIntersecting);
      }
    }
    catch(err){}
    try {
      previousBlock.classList.toggle("transition-from", background.isIntersecting)
    }
    catch(err){}
  })  
}

transitionList.forEach(item =>{
  t_observer.observe(item); 
})
